import { useVehiclePhotosByKind } from 'Components/Gallery';
import type { GalleryImageWithTitle } from 'Components/Gallery/MainGallery/MainGallery';
import BasicThumbnail from 'Components/Thumbnail/BasicThumbnail';
import { triggerSectionImageClickedEvent } from 'Services/analytics/events/galleryEventsRedesign';

import { useGalleryTrigger } from '../../../Components/GalleryProvider';

import styles from './AdditionalInfoGallery.module.scss';

export const AdditionalInfoGallery: React.FC = () => {
	const images = useVehiclePhotosByKind(['additional_image']);

	const openGallery = useGalleryTrigger();

	const handleOnClick = ({ id, kind }: GalleryImageWithTitle) => {
		openGallery({ id });
		triggerSectionImageClickedEvent({ kind });
	};

	return (
		<div className={styles.imageWrapper}>
			{images.map((image) => (
				<BasicThumbnail
					key={image.id}
					authenticated
					alt={image.kind}
					className={styles.thumb}
					height={279}
					image={{
						presets: image.presetsArray,
						url: image.url,
					}}
					imgAttributes={{ 'aria-label': image.kind }}
					onClick={() => handleOnClick(image)}
					rootComponent={'AdditionalInfoGallery'}
					width={372}
				/>
			))}
		</div>
	);
};
